export class HrPayConstantNumberKey {
    private static readonly keyPrefix = 'hrPayConstantNumber';
    public static pageHeader = `${HrPayConstantNumberKey.keyPrefix}.pageHeader`;
    public static value = `${HrPayConstantNumberKey.keyPrefix}.value`;
}
